import AfterSaleManagement from '@/vuepage/after-sale/index';
import AfterSaleList from '../vuepage/after-sale/list';
import AfterSaleDetail from '../vuepage/after-sale/detail';

export default [
  {
    path: '/after-sale-management',
    component: AfterSaleManagement,
    children: [
      {
        path: 'list',
        component: AfterSaleList,
        meta: [
          {
            name: '售后管理',
            url: '/after-sale-management',
          },
          {
            name: '售后列表',
            url: 'list',
          },
        ],
      },
      {
        path: 'detail',
        component: AfterSaleDetail,
        meta: [
          {
            name: '售后管理',
            url: '/after-sale-management',
          },
          {
            name: '售后列表',
            url: 'list',
          },
          {
            name: '售后详情',
            url: 'detail',
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/after-sale.js